export const navTabsOptions = [
  {
    title: 'Audience',
    tab: 1,
    testId: 'insent-audience-tab',
  },
  {
    title: 'Conversation flow',
    tab: 2,
    testId: 'insent-conversation-flow-tab',
  },
];
export const conditionKeyListOptions = {
  email: 'Email',
  company: 'Company',
  number: 'Phone number',
};

export const newConvOptions = {
  true: true,
  false: false,
};

export const operatorsForLists = ['inAny', 'notInAny'];
export const timelineOperators = ['month', '3-months'];
export const timelineOperatorMapping = { 3: '3-months', 1: 'month' };
export const operatorTimelineMapping = { '3-months': 3, month: 1 };
const operatorsForRange = ['inBetween', 'notInBetween', 'greaterThan', 'lessThan'];
const operatorsForSalesForceRange = [
  'inBetween',
  'notInBetween',
  'greaterThan',
  'lessThan',
  'equalTo',
  'notEqual',
];
export const operatorForSalesforce = ['in', 'notIn'];

export const operatorsForURL = [
  'isAny',
  'includesAny',
  'startsWithAny',
  'endsWithAny',
  'isNotAny',
  'notStartsWithAny',
  'notEndsWithAny',
  'notIncludesAny',
  'regexAny',
];

export const operatorsForChatFields = [...operatorsForURL, 'isKnown', 'isUnknown'];
export const operatorsForAccountFields = [...operatorsForURL, 'isKnown', 'isUnknown'];

const operatorsForText = [
  'isAny',
  'includesAny',
  'startsWithAny',
  'endsWithAny',
  'isNotAny',
  'notStartsWithAny',
  'notEndsWithAny',
  'notIncludesAny',
];
export const operatorsForNumbers = ['greaterThan', 'lessThan', 'equalTo', 'notEqual'];

export const VALUE_TYPES = {
  STRING_ARRAY: 'stringArray',
  NUMBER_ARRAY: 'numberArray',
  NUMBER: 'number',
  STRING: 'string',
  RANGE: 'ranged',
  BOOLEAN: 'boolean',
  UNKNOWN: 'unknown',
};

export const operatorForSalesforceLead = ['is'];

export const operatorForCalendarMeeting = ['is', 'isNot'];
export const operatorForCalendarMeetingUpdate = ['isAny', 'isNotAny'];

export const keyMapping = {
  marketoList: { val: 'Marketo list', operators: operatorsForLists },
  insentLeadFields: { val: 'Lead', operators: operatorsForURL },
  insentAccountFields: { val: 'Account', operators: operatorsForAccountFields },
  insentFieldsConditions: { val: 'Lead', operators: operatorsForChatFields },
  hubspotList: { val: 'Hubspot list', operators: operatorsForLists },
  pardotList: { val: 'Pardot list', operators: operatorsForLists },
  eloquaList: { val: 'Eloqua list', operators: operatorsForLists },
  url: { val: 'Visited URL', operators: operatorsForURL },
  siteVisits: { val: 'Number of website visits', operators: operatorsForNumbers },
  timeSpent: { val: 'Total time spent on website', operators: operatorsForNumbers },
  numberOfVisitors: { val: 'Number of visitors', operators: operatorsForNumbers },
  name: { val: 'Company name', operators: operatorsForText },
  domain: { val: 'Web domain', operators: operatorsForText },
  country: { val: 'Country', operators: operatorsForLists },
  region: { val: 'US/Canada region', operators: operatorsForLists },
  employeeRange: { val: 'Employee range', operators: operatorsForRange },
  revenueRange: { val: 'Revenue range', operators: operatorsForRange },
  technology: { val: 'Technologies', operators: operatorsForLists },
  intent: { val: 'Intent', operators: timelineOperators },
  scoop: { val: 'Scoops', operators: timelineOperators },
  industries: { val: 'Industries', operators: operatorsForLists },
  primaryIndustry: { val: 'Primary Industry', operators: operatorsForLists },
  salesforceOwner: { val: 'SF owner', operators: operatorsForLists },
  isSalesforceContact: { val: 'SF contact', operators: operatorForSalesforceLead },
  isSalesforceLead: { val: 'SF lead', operators: operatorForSalesforceLead },
  zohoOwner: { val: 'Zoho owner', operators: operatorsForLists },
  isZohoContact: { val: 'Zoho contact', operators: operatorForSalesforceLead },
  isZohoLead: { val: 'Zoho lead', operators: operatorForSalesforceLead },
  msdynamicsOwner: { val: 'Microsoft Dynamics owner', operators: operatorsForLists },
  isMsdynamicsContact: { val: 'Microsoft Dynamics contact', operators: operatorForSalesforceLead },
  isMsdynamicsLead: { val: 'Microsoft Dynamics lead', operators: operatorForSalesforceLead },
  salesforceTotalOpportunityValue: {
    val: 'SF opportunity',
    operators: operatorsForSalesForceRange,
  },
  salesforceOpportunityCreatedIn: {
    val: 'SF opportunity created',
    operators: operatorForSalesforce,
  },
  salesforceOpportunityRemovedIn: {
    val: 'SF opportunity removed',
    operators: operatorForSalesforce,
  },
  targetAccountList: { val: 'Target Accounts', operators: operatorsForLists },
};
export const operatorMapping = {
  month: { val: 'last month', valueType: VALUE_TYPES.NUMBER_ARRAY },
  '3-months': { val: 'last 3 months', valueType: VALUE_TYPES.NUMBER_ARRAY },
  isAny: { val: 'is', valueType: VALUE_TYPES.STRING_ARRAY },
  isNotAny: { val: 'is not', valueType: VALUE_TYPES.STRING_ARRAY },
  inAny: { val: 'in', valueType: VALUE_TYPES.NUMBER_ARRAY },
  notInAny: { val: 'not in', valueType: VALUE_TYPES.NUMBER_ARRAY },
  startsWithAny: { val: 'starts with', valueType: VALUE_TYPES.STRING_ARRAY },
  notStartsWithAny: { val: 'does not start with', valueType: VALUE_TYPES.STRING_ARRAY },
  endsWithAny: { val: 'ends with', valueType: VALUE_TYPES.STRING_ARRAY },
  notEndsWithAny: { val: 'does not end with', valueType: VALUE_TYPES.STRING_ARRAY },
  includesAny: { val: 'contains', valueType: VALUE_TYPES.STRING_ARRAY },
  notIncludesAny: { val: 'does not contain', valueType: VALUE_TYPES.STRING_ARRAY },
  regexAny: { val: 'regex', valueType: VALUE_TYPES.STRING_ARRAY },
  greaterThan: { val: 'greater than', valueType: VALUE_TYPES.NUMBER },
  lessThan: { val: 'less than', valueType: VALUE_TYPES.NUMBER },
  equalTo: { val: 'equal to', valueType: VALUE_TYPES.NUMBER },
  notEqual: { val: 'not equal to', valueType: VALUE_TYPES.NUMBER },
  inBetween: { val: 'in between', valueType: VALUE_TYPES.RANGE },
  notInBetween: { val: 'not in between', valueType: VALUE_TYPES.RANGE },
  is: { val: 'is', valueType: VALUE_TYPES.BOOLEAN },
  isNot: { val: 'is not', valueType: VALUE_TYPES.BOOLEAN },
  in: { val: 'in the last (days)', valueType: VALUE_TYPES.NUMBER },
  notIn: { val: 'not in the last (days)', valueType: VALUE_TYPES.NUMBER },
  isKnown: { val: 'is known', valueType: VALUE_TYPES.UNKNOWN },
  isUnknown: { val: 'is unknown', valueType: VALUE_TYPES.UNKNOWN },
};

export const rulesMapping = {
  url: { val: 'Visit URL', valueType: VALUE_TYPES.STRING_ARRAY },
  websiteFormSubmit: { val: 'Form Submit', valueType: VALUE_TYPES.STRING },
  clickBasedTrigger: { val: 'Element Click', valueType: VALUE_TYPES.STRING },
};

export const ruleTriggerTypes = {
  websiteFormSubmit: {
    rules: [
      {
        key: 'websiteFormSubmit',
        url: '',
        formId: '',
        formName: '',
        formFields: [],
      },
    ],
  },
  url: {
    rules: [
      {
        key: 'url',
        operator: '',
        value: '',
      },
    ],
  },
};

export const MAP_LIST = {
  MARKETO: 'marketoList',
  HUBSPOT: 'hubspotList',
  INSENT_FIELDS: 'insentFields',
  PARDOT: 'pardotList',
  ELOQUA: 'eloquaList',
};

export const SALESFORCE_KEYS = {
  OWNER: 'salesforceOwner',
  CONTACT: 'isSalesforceContact',
  LEAD: 'isSalesforceLead',
  OPPURTUNITY: 'salesforceTotalOpportunityValue',
  OPPURTUNITY_REMOVED: 'salesforceOpportunityRemovedIn',
  OPPURTUNITY_CREATED: 'salesforceOpportunityCreatedIn',
};

export const ZOHO_KEYS = {
  OWNER: 'zohoOwner',
  CONTACT: 'isZohoContact',
  LEAD: 'isZohoLead',
};

export const MSDYNAMICS_KEYS = {
  OWNER: 'msdynamicsOwner',
  CONTACT: 'isMsdynamicsContact',
  LEAD: 'isMsdynamicsLead',
};

export const GROUP_RULE_TYPE = {
  DOMAIN: 'domain',
  COUNTRY: 'country',
  REGION: 'region',
  EMPLOYEE_RANGE: 'employeeRange',
  REVENUE_RANGE: 'revenueRange',
  TIME_SPENT: 'timeSpent',
  INDUSTRY: 'industries',
  PRIMARY_INDUSTRY: 'primaryIndustry',
  TECHNOLOGIES: 'technology',
  INTENTS: 'intent',
  SCOOPS: 'scoop',
  TARGET_ACCOUNTS: 'targetAccountList',
};

export const OPTION_HEADER = {
  LIST: 'List',
  PAST_WEBSITE_BEHAVIOR: 'Past website behavior',
  FIRMOGRAPHIC: 'Firmographic',
  SALESFORCE: 'SalesForce',
  INSENT: 'Insent',
  ZOHO: 'Zoho',
  MSDYNAMICS: 'Microsoft Dynamics',
};

export const audienceKeys = [
  {
    header: OPTION_HEADER.LIST,
    keys: [
      {
        key: MAP_LIST.MARKETO,
        valueType: 'numberList',
        scope: 'lead',
        appName: 'marketo',
        type: 'integration',
      },
      {
        key: MAP_LIST.HUBSPOT,
        valueType: 'numberList',
        scope: 'lead',
        type: 'integration',
        appName: 'hubspot',
      },
      {
        key: MAP_LIST.PARDOT,
        valueType: 'numberList',
        scope: 'lead',
        type: 'integration',
        appName: 'pardot',
      },
      {
        key: MAP_LIST.ELOQUA,
        valueType: 'numberList',
        scope: 'lead',
        appName: 'eloqua',
        type: 'integration',
      },
    ],
  },
  {
    header: OPTION_HEADER.SALESFORCE,
    keys: [
      {
        key: SALESFORCE_KEYS.OWNER,
        valueType: 'numberList',
        scope: 'account',
        type: 'integration',
        appName: 'salesforce',
      },
      {
        key: SALESFORCE_KEYS.CONTACT,
        valueType: 'numberList',
        scope: 'lead',
        type: 'integration',
        appName: 'salesforce',
      },
      {
        key: SALESFORCE_KEYS.LEAD,
        valueType: 'numberList',
        scope: 'lead',
        type: 'integration',
        appName: 'salesforce',
      },
      {
        key: SALESFORCE_KEYS.OPPURTUNITY,
        valueType: 'numberList',
        scope: 'account',
        type: 'integration',
        appName: 'salesforce',
      },
      {
        key: SALESFORCE_KEYS.OPPURTUNITY_CREATED,
        valueType: 'numberList',
        scope: 'account',
        type: 'integration',
        appName: 'salesforce',
      },
      {
        key: SALESFORCE_KEYS.OPPURTUNITY_REMOVED,
        valueType: 'numberList',
        scope: 'account',
        type: 'integration',
        appName: 'salesforce',
      },
    ],
  },
  {
    header: OPTION_HEADER.ZOHO,
    keys: [
      {
        key: ZOHO_KEYS.OWNER,
        valueType: 'numberList',
        scope: 'account',
        type: 'integration',
        appName: 'zoho',
      },
      {
        key: ZOHO_KEYS.CONTACT,
        valueType: 'numberList',
        scope: 'lead',
        type: 'integration',
        appName: 'zoho',
      },
      {
        key: ZOHO_KEYS.LEAD,
        valueType: 'numberList',
        scope: 'lead',
        type: 'integration',
        appName: 'zoho',
      },
    ],
  },
  {
    header: OPTION_HEADER.MSDYNAMICS,
    keys: [
      {
        key: MSDYNAMICS_KEYS.OWNER,
        valueType: 'numberList',
        scope: 'account',
        type: 'integration',
        appName: 'msdynamics',
      },
      {
        key: MSDYNAMICS_KEYS.CONTACT,
        valueType: 'numberList',
        scope: 'lead',
        type: 'integration',
        appName: 'msdynamics',
      },
      {
        key: MSDYNAMICS_KEYS.LEAD,
        valueType: 'numberList',
        scope: 'lead',
        type: 'integration',
        appName: 'msdynamics',
      },
    ],
  },
  {
    header: OPTION_HEADER.PAST_WEBSITE_BEHAVIOR,
    keys: [
      {
        key: 'url',
        valueType: 'stringList',
        scope: 'lead',
        type: 'behavior',
      },
      {
        key: 'siteVisits',
        valueType: 'number',
        scope: 'lead',
        type: 'behavior',
      },
      {
        key: 'timeSpent',
        valueType: 'number',
        scope: 'lead',
        type: 'behavior',
      },
    ],
  },
  {
    header: OPTION_HEADER.FIRMOGRAPHIC,
    keys: [
      {
        key: 'name',
        scope: 'account',
        type: 'attribute',
      },
      {
        key: 'domain',
        scope: 'account',
        type: 'attribute',
      },
      {
        key: 'country',
        scope: 'account',
        type: 'attribute',
      },
      {
        key: 'region',
        scope: 'account',
        type: 'attribute',
      },
      {
        key: 'employeeRange',
        scope: 'account',
        type: 'attribute',
      },
      {
        key: 'revenueRange',
        scope: 'account',
        type: 'attribute',
      },
      {
        key: 'industries',
        scope: 'account',
        type: 'attribute',
      },
      {
        key: 'primaryIndustry',
        scope: 'account',
        type: 'attribute',
      },
      {
        key: 'technology',
        scope: 'account',
        type: 'ziIntelligence',
      },
      {
        key: 'intent',
        scope: 'account',
        type: 'ziIntelligence',
      },
      {
        key: 'scoop',
        scope: 'account',
        type: 'ziIntelligence',
      },
    ],
  },
  {
    header: OPTION_HEADER.INSENT,
    keys: [
      {
        key: MAP_LIST.INSENT_FIELDS,
        valueType: 'stringList',
        scope: 'objectField',
        type: 'integration',
        appName: 'insent',
      },
    ],
  },
];

export const conditionStepOptions = [
  { value: 'conditions', label: 'Conditions', isDisabled: true },
  { value: 'all', label: 'Matching all of these rules', index: 0 },
  { value: 'any', label: 'Matching any of these rules', index: 1 },
];

export const alertToOptions = {
  everyone: 'All Users (Round Robin)',
  everyoneInRoundrobin: 'All Users in Channel (Round Robin)',
  individuals: 'Selected Users/Teams (Round Robin)',
  channelSelectedParticipants: 'Selected Users/Teams in Channel',
  ringLeadRouting: 'Ringlead Routing',
  salesforceAccountOwner: 'SF Account Owner',
  salesforceLeadOwner: 'SF Lead Owner',
  salesforceContactOwner: 'SF Contact Owner',
  zohoAccountOwner: 'Zoho Account Owner',
  zohoLeadOwner: 'Zoho Lead Owner',
  zohoContactOwner: 'Zoho Contact Owner',
  msdynamicsAccountOwner: 'Microsoft Dynamics Account Owner',
  msdynamicsLeadOwner: 'Microsoft Dynamics Lead Owner',
  msdynamicsContactOwner: 'Microsoft Dynamics Contact Owner',
  hubspotAccountOwner: 'Hubspot Account Owner',
  hubspotContactOwner: 'Hubspot Contact Owner',
};

export const customFieldRuleValue = 'customRoutingRules';

export const alertToKeys = {
  EVERYONE: 'everyone',
  EVERYONE_IN_ROUNDROBIN: 'everyoneInRoundrobin',
  INDIVIDUALS: 'individuals',
  CHANNEL_SELECTED_PARTICIPANTS: 'channelSelectedParticipants',
  RINGLEAD_ROUTING: 'ringLeadRouting',
  SALESFORCE_ACCOUNT_OWNER: 'salesforceAccountOwner',
  SALESFORCE_LEAD_OWNER: 'salesforceLeadOwner',
  SALESFORCE_CONTACT_OWNER: 'salesforceContactOwner',
  HUBSPOT_ACCOUNT_OWNER: 'hubspotAccountOwner',
  HUBSPOT_CONTACT_OWNER: 'hubspotContactOwner',
  ZOHO_ACCOUNT_OWNER: 'zohoAccountOwner',
  ZOHO_CONTACT_OWNER: 'zohoContactOwner',
  ZOHO_LEAD_OWNER: 'zohoLeadOwner',
  MSDYNAMICS_ACCOUNT_OWNER: 'msdynamicsAccountOwner',
  MSDYNAMICS_CONTACT_OWNER: 'msdynamicsContactOwner',
  MSDYNAMICS_LEAD_OWNER: 'msdynamicsLeadOwner',
};

export const serviceCloudFilterList = [
  'salesforceAccountOwner',
  'salesforceContactOwner',
  'hubspotAccountOwner',
  'hubspotContactOwner',
  'salesforceLeadOwner',
  'zohoAccountOwner',
  'zohoContactOwner',
  'zohoLeadOwner',
  'msdynamicsAccountOwner',
  'msdynamicsContactOwner',
  'msdynamicsLeadOwner',
];

export const roundRobinSettingsKeys = [
  'everyone',
  'everyoneInRoundrobin',
  'channelSelectedParticipants',
  'individuals',
  'ringLeadRouting',
];

export const routingMediums = {
  app: 'Inbox',
  slack: 'Slack',
  msteams: 'MS Teams',
};

export const zendeskGotoText = {
  zendeskCreateTicket: 'Redirect to path',
  zendeskSearchKnowledgeBase: 'Redirect to path',
};

export const US_CANADA_REGION = {
  key: 'region',
  scope: 'account',
  type: 'attribute',
  label: 'US/Canada region',
  defaultField: true,
  fieldType: 'string',
};
